import Matter from "matter-js";

export const run = (engine: Matter.Engine, render: Matter.Render) => {
  Matter.Render.run(render);
  Matter.Runner.run(Matter.Runner.create(), engine);
}